import React, { createContext } from 'react'
import {
	defaultMapControlsAreasCablesBoxesContextData,
	MapControlsAreasCablesBoxesContextData,
} from './MapControlsAreasCablesBoxesContextData'

export const MapControlsAreasCablesBoxesContext: React.Context<MapControlsAreasCablesBoxesContextData> = createContext(
	defaultMapControlsAreasCablesBoxesContextData
)
